var _a, _b, _c, _d;
import i18next from "i18next";
import { html } from "lit-html";
export const DEFAULT_MASTER_DATA_SUB_MENUS = [
  {
    label: i18next.t("Amazon SKUs"),
    key: "admin/master-data/amazon-skus",
    icon: html`&#9679;`
  },
  {
    label: i18next.t("VAT Rates"),
    key: "admin/master-data/default-vat-rates",
    icon: html`&#9679;`
  }
];
export const MASTER_DATA_TAX_CODES_SUB_MENU = {
  label: i18next.t("Tax Codes"),
  key: "admin/master-data/tax-codes",
  icon: html`&#9679;`
};
export const MASTER_DATA_DATA_TEMPLATE_SUB_MENU = {
  label: i18next.t("Data Template"),
  key: "admin/master-data/data-template",
  icon: html`&#9679;`
};
export const MENU_LABELS = {
  SERVICES: i18next.t("Services"),
  BUSINESS_DETAILS: i18next.t("Business Details"),
  USER_MANAGEMENT: i18next.t("User Management"),
  ORDER_HISTORY: i18next.t("Order History"),
  DATA_UPLOAD: i18next.t("Data Upload"),
  MASTER_DATA: i18next.t("Master Data"),
  MASTER_DATA_TAX_CODES: i18next.t("Tax Codes"),
  MASTER_DATA_TEMPLATES: i18next.t("Data Template"),
  RETURN_LIBRARY: i18next.t("Return Library"),
  CESOP: i18next.t("CESOP")
};
export const DEFAULT_MAIN_MENU = [
  {
    label: i18next.t("Services"),
    key: "admin/services(/manage)",
    icon: "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v340a6 6 0 0 1-6 6zm-42-92v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm-252 12c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36z",
    hidden: ClientContext.IsPspUser
  },
  {
    label: i18next.t("Business Details"),
    key: "admin/business-details",
    icon: "M527.9 224H480v-48c0-26.5-21.5-48-48-48H272l-64-64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h400c16.5 0 31.9-8.5 40.7-22.6l79.9-128c20-31.9-3-73.4-40.7-73.4zM48 118c0-3.3 2.7-6 6-6h134.1l64 64H426c3.3 0 6 2.7 6 6v42H152c-16.8 0-32.4 8.8-41.1 23.2L48 351.4zm400 282H72l77.2-128H528z",
    hidden: ClientContext.IsPspUser || !((_a = ClientContext.CompanyInformation) == null ? void 0 : _a.IsFullComplianceAllowed)
  },
  {
    label: i18next.t("User Management"),
    key: "admin/client-accounts",
    icon: "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm0 464H48V48h288v416zM144 112h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16zm48 176c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"
  },
  {
    label: i18next.t("Order History"),
    key: "admin/orders(/:orderId)",
    icon: "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 80v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8zm144 263.88V440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V232c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v24.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07z",
    hidden: ClientContext.IsPspUser || !((_b = ClientContext.CompanyInformation) == null ? void 0 : _b.IsNewOrderAllowed)
  },
  {
    label: i18next.t("Data Upload"),
    key: "admin/compliance-upload",
    icon: "M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z",
    hidden: ClientContext.IsPspUser || !((_c = ClientContext.CompanyInformation) == null ? void 0 : _c.IsFullComplianceAllowed)
  },
  {
    label: i18next.t("Master Data"),
    key: "admin/master-data",
    icon: "M567.403 235.642L462.323 84.589A48 48 0 0 0 422.919 64H153.081a48 48 0 0 0-39.404 20.589L8.597 235.642A48.001 48.001 0 0 0 0 263.054V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V263.054c0-9.801-3-19.366-8.597-27.412zM153.081 112h269.838l77.913 112H75.168l77.913-112zM528 400H48V272h480v128zm-32-64c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32zm-96 0c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32z",
    hidden: ClientContext.IsPspUser || !((_d = ClientContext.CompanyInformation) == null ? void 0 : _d.IsFullComplianceAllowed),
    submenus: DEFAULT_MASTER_DATA_SUB_MENUS
  },
  {
    label: i18next.t("Return Library"),
    key: "admin/return-library",
    icon: "M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z",
    hidden: ClientContext.IsPspUser
  },
  {
    label: i18next.t("CESOP"),
    key: "admin/cesop",
    icon: "M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z",
    hidden: !ClientContext.IsPspUser,
    submenus: [
      {
        label: i18next.t("Periods"),
        key: "admin/cesop/periods",
        icon: html`&#9679;`
      },
      {
        label: i18next.t("Company Data"),
        key: "admin/cesop/company-data",
        icon: html`&#9679;`
      }
    ]
  }
];
